import { MODULE_SCOPES } from "../constants/moduleScopes";
import { useModuleAccess } from "../hooks/useModuleAccess";
import ModuleAccessDenied from "./ModuleAccessDenied";

/**
 * Route guard enforcing per-module access scope.
 *
 * Renders its children only when the active workspace's scope grants access to
 * `module`; otherwise renders an Access Denied page. Admins and users with a
 * null product_scopes bypass the check (see useModuleAccess / hasModuleAccess).
 *
 * Intended to wrap a page INSIDE GeneralLayout so the denied state keeps the
 * app shell (sidebar + CTA).
 *
 * @param {{ module: string, children: React.ReactNode }} props
 */
const ModuleProtectedRoute = ({ module, children }) => {
  const { canAccess } = useModuleAccess();

  if (!canAccess(module)) {
    const label = MODULE_SCOPES.find((m) => m.key === module)?.label;
    return <ModuleAccessDenied moduleLabel={label} />;
  }

  return children;
};

export default ModuleProtectedRoute;
